// extracted by mini-css-extract-plugin
module.exports = {"dashBlock":"styles_dashBlock__Pjp93","dashContent":"styles_dashContent__1KL1_","short":"styles_short__vAHhP","loader":"styles_loader__3GrAu"};